import React from 'react';

const STEPS = [
  { title: 'PLZ eingeben', text: 'Du gibst deine Postleitzahl ein, mehr braucht es zum Start nicht.' },
  { title: 'Kanal wählen', text: 'Telegram, Push oder E-Mail — du entscheidest, wo die Meldung ankommt.' },
  { title: 'Meldung bekommen', text: 'Sobald ein passendes Inserat online geht, schicken wir dir die Meldung.' },
];

/** A real 3-step sequence, so it is the one place besides the speed timeline with numbered markers. */
export const HowItWorks: React.FC = () => (
  <section id="how" className="scroll-mt-20 border-b border-line bg-card py-16 md:py-24">
    <div className="mx-auto w-full max-w-wide px-4 md:px-6">
      <h2 className="font-display text-2xl text-ink md:text-3xl">So funktioniert&rsquo;s</h2>

      <ol className="mt-8 grid gap-8 md:grid-cols-3">
        {STEPS.map((step, index) => (
          <li key={step.title} className="flex flex-col gap-2">
            <span className="tabular flex h-9 w-9 items-center justify-center rounded-full bg-brand-soft font-display text-lg text-on-brand-soft">
              {index + 1}
            </span>
            <h3 className="font-display text-lg text-ink">{step.title}</h3>
            <p className="text-sm text-muted">{step.text}</p>
          </li>
        ))}
      </ol>

      <p className="mt-8 text-sm text-muted">Filter wie Miete, Zimmer und WBS stellst du danach in deinen Suchen ein.</p>
    </div>
  </section>
);

export default HowItWorks;
